<template>
  <div class="title-wrap">
    <div v-if="!$slots.left">
      <i v-if="showReturn" class="el-icon-back" @click="returnLink"></i>
      <span class="title">{{ title }}</span>
    </div>
    <slot name="left"></slot>
    <slot name="right"></slot>
  </div>
</template>

<script>
import i18n from "@/locales/i18n";
export default {
  name: "TitleWrap",
  props: ["title", "showReturn"],
  mounted() {
    if (this.$route.path === "/filingCreate") {
      window.history.pushState(null, null, window.location.href);
    }
  },
  methods: {
    returnLink() {
      if (this.$route.path === "/filingCreate") {
        this.preventBack();
      } else {
        // 添加返回路由逻辑
        const route = this.$routeStack.pop();
        // console.log('返回路由',route)
        this.$router.push(route);
      }
    },
    preventBack() {
      this.$confirm(
        i18n.t("pricePlan.isAbandonChanges"),
        i18n.t("common.notice"),
        {
          confirmButtonText: i18n.t("common.confirm"),
          cancelButtonText: i18n.t("common.cancel"),
          closeOnClickModal: false,
          closeOnPressEscape: false,
          distinguishCancelAndClose: true,
          type: "warning",
          callback: (action) => {
            if (action == "confirm") {
              // this.$router.push({ path: "/chain-filing" });
              // 添加返回路由逻辑
              const route = this.$routeStack.pop();
              // console.log('返回路由',route)
              this.$router.push(route);
            } else if (action == "cancel") {
              window.history.pushState(null, null, window.location.href);
            } else if (action == "close") {
              window.history.pushState(null, null, window.location.href);
            }
          },
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.title-wrap {
  padding-left: 20px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    display: inline-flex;
    align-items: center;
  }
  .el-icon-back {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 18px;
    width: 36px;
    height: 36px;
    font-weight: bold;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 14px;
  }
  .title {
    font-size: 28px;
    color: #000;
  }
}
</style>
